import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom'
import {scrollToElement} from "../../utilities";
import { StyledNavigation } from "./styled";
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import { LazyLoadImage } from 'react-lazy-load-image-component';

const menuItems = [
    {
        title: 'Home',
        href: '/',
        className: 'Navigation-links',
        selectable: true,
    },
    {
        title: 'Products',
        href: '#',
        selectable: true,
        subMenuItems: [
            {
                title: 'Mailwall',
                subTitle: 'Email Filtering',
                href: '/mailwall-email-filtering',
                selectable: true,
            },
            {
                title: 'Surfwall',
                subTitle: 'Internet Security',
                href: '/surfwall-internet-security',
                selectable: true,
            },
            {
                title: 'Email Archiving',
                subTitle: 'Email Backup & Recovery',
                href: '/email-archiving-secure-backup-and-recovery',
                selectable: true,
            },
            {
                title: 'Phishwise',
                subTitle: 'Internet Security Training',
                href: '/phishwise-internet-security-training',
                selectable: true,
            },
            {
                title: 'Mailwall Office 365',
                subTitle: 'Mailwall Office365 Protection',
                href: '/office365',
                selectable: true,
            },
        ]
    },
    {
        title: 'News & Events',
        href: '/news',
        selectable: true,
    },
    {
        title: 'Contact',
        href: 'ContactForm',
        selectable: false,
        anchor: true,
        offset: -60,
    },
]

const MenuItem = ({item, expandedMenu, setExpandedMenu, handleMenuChange}) => {
    const location = useLocation();
    const hasSubmenuItems = item.subMenuItems && item.subMenuItems.length
    const expandedClassName = expandedMenu === item.href && hasSubmenuItems ? 'expanded' : ''
    const submenuClassName = `Navigation-submenu ${expandedClassName}`

    let selectedMenuClassName = location.pathname === item.href ? 'selected' : ''

    if (item.href === '/news' && /\/news\//.test(location.pathname)) {
        selectedMenuClassName = 'selected'
    }


    if (hasSubmenuItems) {
        const renderSubmenu = item.subMenuItems.map((submenuItem, index) => {
            const selectedSubmenuClassName = location.pathname === submenuItem.href ? 'selected' : ''

            if (selectedSubmenuClassName) {
                selectedMenuClassName = 'selected'
            }

            const subTitle = submenuItem.subTitle ? <span>{submenuItem.subTitle}</span> : ''
            return (
                <li key={`Navigation-submenu-${index}`}>
                    <Link
                        className={selectedSubmenuClassName}
                        to={submenuItem.href}
                        onClick={() => setExpandedMenu('')}
                    >
                        {submenuItem.title} {subTitle}
                    </Link>
                </li>
            )
        })

        const caret = expandedMenu === item.title ? <FaCaretUp size="14px"/> : <FaCaretDown size="14px"/>

        return (
            <li>
                <button className={selectedMenuClassName} onClick={() => handleMenuChange(item.href)}>
                    {item.title}&nbsp;
                    {item.subMenuItems && caret}
                </button>

                <ul className={submenuClassName}>
                    {renderSubmenu}
                </ul>
            </li>
        )
    }

    // const menuToSelect = item.selectable ? item.title : selectedMenu
    const clickAction = item.selectable ? () => handleMenuChange(item.href) : null

    if (item.anchor) {
        return (
            <li>
                <button
                    className={selectedMenuClassName}
                    onClick={() => scrollToElement(item.href, item.offset)}
                >
                    {item.title}
                </button>
            </li>
        )
    }

    return (
        <li>
            <Link
                className={selectedMenuClassName}
                to={item.href}
                onClick={clickAction}
            >
                {item.title}
            </Link>
        </li>
    )
}



const Navigation = () => {
    const [expandedMenu, setExpandedMenu] = useState('')

    const handleMenuChange = (href) => {
        if (expandedMenu === href) {
            return setExpandedMenu('')
        }

        setExpandedMenu(href)
    }


    const renderMenu = menuItems.map((item, index) => {
        return (
            <MenuItem
                item={item}
                expandedMenu={expandedMenu}
                setExpandedMenu={setExpandedMenu}
                handleMenuChange={handleMenuChange}
                key={`Navigation-menu-${index}`}
            />
        )
    })

    return (
        <StyledNavigation className="Navigation">
            <div className="Navigation-box">
                <div className="Navigation-logo">
                    <Link to="/">
                        <LazyLoadImage
                            src="/omniquad-logo.png"
                            width={180}
                            height={50}
                            alt="React Bootstrap logo"
                        />
                    </Link>
                </div>
                <ul className="Navigation-menu">
                    {renderMenu}
                </ul>
            </div>
        </StyledNavigation>
    )
}

export default Navigation;